import { render, staticRenderFns } from "./TopPortfolioDailyPl.vue?vue&type=template&id=2499811a&"
import script from "./TopPortfolioDailyPl.vue?vue&type=script&lang=js&"
export * from "./TopPortfolioDailyPl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports